<template>
  <div class="vuestic-modal">
    <transition name="modal" :duration="duration">
      <div v-if="show" class="modal-container">
        <div class="modal" :class="modalClass" @click.self="clickMask">
          <div class="modal-dialog" :class="modalDialogClass">
            <div class="modal-content">
              <!--Header-->
              <div class="modal-header">
                <slot name="header">
                  <div class="modal-title">
                    <slot name="title"></slot>
                  </div>

                  <i
                    class="ion ion-md-close close-modal"
                    v-if="closeIconShown"
                    @click.prevent="cancel"
                  />
                </slot>
              </div>
              <!--Container-->
              <div class="modal-body">
                <slot></slot>
              </div>
              <!--Footer-->
              <div class="modal-footer" v-if="footerShown">
                <slot name="footer">
                  <button
                    type="button"
                    v-if="cancelView"
                    :class="cancelClass"
                    @click="cancel"
                  >
                    {{ cancelText }}
                  </button>
                  <button
                    type="button"
                    v-if="acceptValidation"
                    :class="okClass"
                    @click="ok"
                  >
                    {{ okText }}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import { zoomOutMobile } from "../../services/utils";
export default {
  name: "vuestic-modal",
  props: {
    transition: {
      type: String,
      default: "modal",
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    force: {
      type: Boolean,
      default: false,
    },
    okText: {
      type: String,
      default: "Confirmer",
    },
    cancelView: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: "Annuler",
    },
    closeIconShown: {
      type: Boolean,
      default: true,
    },
    footerShown: {
      type: Boolean,
      default: true,
    },
    okClass: {
      type: String,
      default: "btn btn-primary",
    },
    cancelClass: {
      type: String,
      default: "btn btn-secondary",
    },
    modalClass: {
      type: String,
      default: "",
    },
    okFunction: {
      type: Function,
    },
  },
  data() {
    return {
      show: false,
      duration: 500,
      acceptValidation: true,
    };
  },
  computed: {
    modalDialogClass() {
      return {
        "modal-lg": this.large,
        "modal-sm": this.small,
      };
    },
  },
  created() {
    if (this.show) {
      document.body.className += " modal-open";
    }
  },
  beforeDestroy() {
    document.body.className = document.body.className.replace(
      /\s?modal-open/,
      ""
    );
  },
  watch: {
    show(value) {
      if (value) {
        document.body.className += " modal-open";
      } else {
        window.setTimeout(() => {
          document.body.className = document.body.className.replace(
            /\s?modal-open/,
            ""
          );
        }, this.duration);
      }
    },
  },
  methods: {
    ok() {
      if (this.okFunction) {
        if (this.okFunction()) {
          this.$emit("ok");
          this.show = false;
        }
      } else {
        this.$emit("ok");
        this.show = false;
      }
    },
    cancel() {
      this.$emit("cancel");
      this.show = false;
    },
    clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open() {
      this.show = true;
      zoomOutMobile(screen);
    },
    disableOkButton() {
      this.acceptValidation = false;
    },
    activateOkButton() {
      this.acceptValidation = true;
    },
  },
};
</script>

<style lang="scss">
.vuestic-modal {
  height: 0;
  width: 0;
  // For Transitioning
  .modal {
    z-index: 3;
    display: block;
  }

  .modal-dialog,
  .modal-backdrop {
    transition: all 0.5s ease;
    z-index: 2;
  }

  .modal-enter .modal-dialog,
  .modal-leave-active .modal-dialog {
    opacity: 0;
    transform: translateY(-30%);
  }

  .modal-enter .modal-backdrop,
  .modal-leave-active .modal-backdrop {
    opacity: 0;
  }

  .modal-backdrop {
    opacity: 0.5;
    min-width: 100%;
    min-height: 100%;
  }

  //Modal styles

  .modal-header {
    height: $modal-header-height;
    padding: $modal-header-padding-y $modal-header-padding-x;
    border-bottom: $modal-header-border;
    font-size: $font-size-larger;
    font-family: $font-family-titles;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .close-modal {
    margin-left: 1rem;
    font-size: $font-size-large;
    line-height: $font-size-large;
    cursor: pointer;
  }

  .modal-content {
    border-radius: $modal-content-border-radius;
  }

  .modal-footer {
    justify-content: center;
    padding: 0 $modal-inner-padding-eveler;
    padding-bottom: calc(
      #{$modal-inner-padding-eveler} - #{$modal-footer-btns-padding-bottom}
    );
    flex-wrap: wrap;
    .btn {
      margin: 0 $modal-footer-btns-margin-x $modal-footer-btns-padding-bottom
        $modal-footer-btns-margin-x;
    }
  }

  .modal-dialog {
    box-shadow: $modal-content-box-shadow-sm-up;
  }
}
</style>
